<template>
  <page-component
    id="loginresumesession"
    header="Login Warning - Active Session Alert">
    <form
      ref="form"
      class="novalidate"
      :action="baseHref + 'login.html'"
      method="post"
      @submit.prevent="onSubmit()">
      <input
        type="hidden"
        name="Action"
        value="process" />
      <input
        type="hidden"
        name="SubAction"
        value="" />
      <input
        type="hidden"
        name="_csrf_token"
        :value="crsfToken" />
      <input
        type="hidden"
        name="loginresumesession_continue"
        value="yes" />

      <p>
        An active session already exists for your account. This session may have
        been started on another device or in another browser. The existing
        active session was started on
        {{ $filters.formatDateTime(startedAt, 'DATETIME_MED') }} and was last
        active at {{ $filters.formatDateTime(activeAt, 'DATETIME_MED') }}. The
        existing session has {{ numberincart }}
        items currently in the shopping cart.
      </p>

      <p>
        If you choose to <strong>Continue with Login</strong>, then the previous
        session will be ended, and any transactions that were in process or in
        the shopping cart will be transferred to your new session.
      </p>

      <group-component
        header="Why am I seeing this?"
        collapsible
        collapsed>
        <p>
          The site allows a maximum of one (1) active session per account. If
          you are seeing this message, then you may have already be logged into
          the site, or you were recently browsing the site from another device
          or browser and did not logout.
        </p>
      </group-component>

      <group-component
        header="Is it safe to continue?"
        collapsible
        collapsed>
        <p>
          It is recommended that you check with other members of your household
          to confirm they are not actively processing a transaction prior to
          continuing with login. If the active session referenced above is one
          you recognize and would like to takeover, then proceed using the
          <strong>Continue with Login</strong> option. Active sessions with
          items in the cart will be ended automatically after
          {{ sessiontimeoutincart }} minutes of inactivity. Active sessions
          without an item in the cart will be ended automatically after
          {{ sessiontimeoutinactive }} minutes of inactivity.
        </p>
      </group-component>

      <group-component>
        <button
          id="loginresumesession_buttoncontinue"
          type="button"
          class="button primary"
          :disabled="processing"
          @click.prevent="onSubmit()">
          Continue with Login
        </button>
        <button
          id="loginresumesession_buttoncancel"
          type="button"
          class="button"
          :disabled="processing"
          @click.prevent="onCancel()">
          Cancel Login
      </button>
      </group-component>
    </form>
  </page-component>
</template>

<script>
export default {
  name: 'LoginResumeSession',
  props: {
    sessionstartedat: String,
    sessionactiveat: String,
    numberincart: {
      default: 0,
      type: Number
    },
    sessiontimeoutincart: {
      default: 0,
      type: Number
    },
    sessiontimeoutinactive: {
      default: 0,
      type: Number
    }
  },
  data() {
    return {
      processing: false,
      crsfToken: App.settings.CSRFToken,
      baseHref: App.settings.BaseHref,
      startedAt: new Date(),
      activeAt: new Date()
    }
  },
  created() {
    this.startedAt = new Date(this.sessionstartedat)
    this.activeAt = new Date(this.sessionactiveat)

    console.log('sessionstartedat', this.sessionstartedat, this.startedAt)
    console.log('sessionactiveat', this.sessionactiveat, this.activeAt)
  },
  methods: {
    onSubmit() {
      this.processing = true
      this.$refs.form.submit() // Use to submit form after checks
    },
    onCancel() {
      this.processing = true
      window.location.href = this.baseHref + 'login.html?_csrf_token=' + this.crsfToken
    }
  }
}
</script>

<style lang="less" scoped>
#loginresumesession_buttoncancel {
  margin-top: 0.5rem;
}
</style>
